import { InvoiceLine } from '@apply/api/src/api/PaymentApi';
import { Title } from './components/Title';
import { TableRow } from './components/TableRow/TableRow';

export type AppraisalInvoiceProps = {
    appraisalInvoice: InvoiceLine[];
    total?: number;
};

export const AppraisalInvoice: React.FC<AppraisalInvoiceProps> = ({ appraisalInvoice = [], total }) => {
    const totalUnderWritings = appraisalInvoice.reduce(
        (totalUnderWritings, listing) => (totalUnderWritings = totalUnderWritings + listing.underwritingFee),
        0
    );

    return (
        <div className='row appraisal-section appraisal-invoice-section'>
            <div className='columns'>
                <Title totalUnderWritings={totalUnderWritings} />
                <div className='appraisal-invoice-content'>
                    {appraisalInvoice.map((invoiceLine, index) => (
                        <TableRow
                            key={index}
                            index={index}
                            invoiceLine={invoiceLine}
                            totalUnderWritings={totalUnderWritings}
                        />
                    ))}
                    <div className='invoice-type invoice-total'></div>
                    <div className='invoice-cost invoice-total'>Total:</div>
                    <div className='invoice-subtotal invoice-total'>${total}</div>
                    <div className='invoice-notes invoice-total'></div>
                </div>
            </div>
        </div>
    );
};
